import React from 'react';
import './ConsentAlert.css';

const ConsentAlert = ({ onAccept, onDecline }) => {
  return (
    <div className="consent-banner">
      <div className="consent-content">
        <div className="consent-text-section">
          <h2 className="consent-title">We Value Your Privacy</h2>
          <p className="consent-message">
            We use cookies and analytics tools to improve your experience and understand how you interact with our website. By accepting, you agree to our use of Google Analytics for tracking website usage.
          </p>
          <ul className="consent-list">
            <li>Pages you visit</li>
            <li>Time spent on the site</li>
            <li>General location (country/city)</li>
            <li>Device and browser information</li>
          </ul>
        </div>
        <div className="consent-buttons">
          <button
            className="consent-button consent-accept"
            onClick={onAccept}
            aria-label="Accept analytics tracking"
          >
            Accept
          </button>
          <button
            className="consent-button consent-decline"
            onClick={onDecline}
            aria-label="Decline analytics tracking"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentAlert;
